/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Image {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { Section, CmsImage } from "@bw/bits"
import { graphql } from "gatsby"
import { Image as ImageModule } from "@bw/modules"

const Image = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  idAttribute,
  classAttribute,
  legend,
  displaySize,
  desktopImage,
  backgroundVariant,
  isFollowedByModuleWithBackgroundVariant,
}) => {
  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition,
        idAttribute,
        classAttribute,
        backgroundVariant,
        isFollowedByModuleWithBackgroundVariant,
      }}
      containerSize={displaySize.value === "large" ? "large" : "medium"}
    >
      <ImageModule
        legend={legend}
        image={<CmsImage src={desktopImage} alt={desktopImage?.alt} />}
      />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on ImageModule {
 *   ...ImageModuleFragment
 * }
 *
 * This is also what you will get in the props of your Image
 * resolver component.
 */
export const query = graphql`
  fragment ImageModuleFragment on ImageModule {
    legend
    displaySize {
      value
    }
    desktopImage {
      alt
      localImage {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  }
`

export { Image }
